<section class="submission-lab grid min-w-0 w-full max-w-full gap-4 overflow-x-hidden">
  <article
    class="w-full max-w-full overflow-x-hidden rounded-3xl border border-line bg-surface p-2 shadow-md">
    <div
      class="submission-lab-toolbar flex min-w-0 flex-col gap-3  pb-1 lg:flex-row lg:items-center lg:justify-between">
      <div class="min-w-0">
        <!-- <div class="flex items-center gap-2">
          <p class="app-kicker m-0 uppercase tracking-[0.18em] 
                    app-kicker rounded-full bg-status-success/10 px-3 py-1.5  text-status-success  
          ">Submission Queue
          </p>
          <button class="submission-queue-settings" type="button" aria-label="Submission queue settings" title="Submission queue settings"
            (click)="openQuestionManagement()">
            <i class="fa-solid fa-gear text-[0.72rem]"></i>
          </button>
        </div> -->

        <!-- <h3 class="app-section-title mt-2 font-bold text-content-light dark:text-content-dark">Operational review table
        </h3> -->
      </div>
      @if(transientSocketStatus()) {
      <div class="flex items-center">
          <div class="inline-flex max-w-full items-start gap-2 rounded-2xl border border-line bg-ai-soft px-3 py-2">
            <uw-icon name="sparkles" [size]="13" class="mt-0.5 text-ai" />
            <div class="min-w-0">
              <div class="typo-label text-ai">{{ transientSocketStatus()?.title }}</div>
              <div class="text-[11.5px] text-text-secondary">{{ transientSocketStatus()?.detail }}</div>
            </div>
          </div>
      </div>
      }
      <div class="flex flex-wrap items-center gap-3 lg:justify-end">
        <div class="relative">
          <button #tableColumnsTrigger
            class="inline-flex h-7 items-center justify-center gap-2 rounded-lg border border-line bg-surface-elevated px-2 text-[11.5px] font-medium text-text-primary transition hover:border-primary hover:text-primary"
            type="button" aria-label="Choose visible columns" [attr.aria-expanded]="tableColumnsPopoverOpen()"
            (click)="toggleTableColumnsPopover($event)">
            <uw-icon name="columns" [size]="13" class="text-text-muted" />
            <span class="text-[11.5px]">Columns</span>
          </button>
          @if (tableColumnsPopoverOpen()) {
          <div #tableColumnsPopover
            class="absolute right-0 top-[calc(100%+0.5rem)] z-[9] w-[min(92vw,20rem)] overflow-hidden rounded-xl border border-line bg-surface-elevated p-2 shadow-lg max-sm:left-0 max-sm:right-auto max-sm:w-[min(92vw,20rem)]"
            (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
            <div class="flex items-start justify-between gap-3">
              <div>
                <!-- <p class="typo-label m-0">Table
                  Columns</p> -->
                <h4 class="typo-title mt-1 text-[12px] text-text-primary">Choose visible columns</h4>
                <p class="typo-caption mt-0.5 text-[10.5px]">Saved per user automatically.</p>
              </div>
              <button
                class="inline-flex h-6 cursor-pointer items-center justify-center rounded-md border border-line bg-surface px-2 text-[10.5px] font-semibold text-text-secondary transition duration-150 ease-in-out hover:border-primary hover:bg-primary hover:text-white active:scale-[0.98]"
                type="button" (click)="resetTableColumns()">
                Reset defaults
              </button>
            </div>

            <div class="mt-2 grid max-h-[min(50vh,360px)] grid-cols-1 gap-1 overflow-auto pr-[0.15rem]">
              @for (column of tableColumnOptions; track column.key) {
              <label
                class="inline-flex cursor-pointer items-center gap-2 rounded-lg border border-line bg-surface px-2.5 py-1.5 text-[10.5px] font-semibold text-text-secondary transition duration-150 ease-in-out hover:-translate-y-px hover:border-primary hover:text-primary">
                <input type="checkbox" [checked]="isTableColumnVisible(column.key)"
                  class="h-3.5 w-3.5 shrink-0 cursor-pointer accent-primary"
                  (change)="updateTableColumnVisibility(column.key, $event)" />
                <span class="text-[10.5px] leading-4">{{ column.label }}</span>
              </label>
              }
            </div>
          </div>
          }

        </div>

        <!-- @if (canToggleUnderwriterScope()) { -->
        <div class="inline-flex rounded-xl border border-line bg-surface p-1 shadow-sm" role="radiogroup" aria-label="Submission scope">
          @for (option of underwriterScopeOptions; track option.value) {
          <button class="inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1 text-[11.5px] font-semibold transition-colors" type="button" role="radio"
            [attr.aria-checked]="isUnderwriterScopeSelected(option.value)"
            [class.bg-primary]="isUnderwriterScopeSelected(option.value)"
            [class.text-white]="isUnderwriterScopeSelected(option.value)"
            [class.bg-transparent]="!isUnderwriterScopeSelected(option.value)"
            [class.text-text-secondary]="!isUnderwriterScopeSelected(option.value)"
            [class.hover:bg-surface-sunken]="!isUnderwriterScopeSelected(option.value)"
            (click)="selectUnderwriterScope(option.value)">
            <span class="h-1.5 w-1.5 rounded-full" [class.bg-surface]="isUnderwriterScopeSelected(option.value)"
              [class.bg-primary]="!isUnderwriterScopeSelected(option.value)" aria-hidden="true"></span>
            <span>{{ option.label }}</span>
          </button>
          }
        </div>
        <!-- } -->
        <label class="flex items-center gap-2 text-[11.5px] text-text-secondary">
          <span>Rows</span>
          <select
            class="h-7 rounded-lg border border-line bg-surface px-2 text-[11.5px] text-text-primary outline-none transition focus:border-primary focus:ring-2 focus:ring-primary/10"
            [value]="pageLimit()" (change)="handleLimitChange($event)">
            @for (option of pageLimitOptions(); track option) {
            <option [value]="option">{{ option }}</option>
            }
          </select>
        </label>
        <!-- <span class="app-kicker rounded-full bg-status-success/10 px-3 py-1.5 font-semibold text-status-success">Live
          submissions</span> -->
        <!-- <span class="app-kicker rounded-full bg-brand/10 px-3 py-1.5 font-semibold text-brand">Presenter data</span> [rowClass]="submissionRowClass" -->
      </div>
    </div>

    <div #tableShell
      class="mt-0 w-full max-w-full overflow-hidden rounded-md border border-line bg-surface">
      <div class="overflow-x-auto">
        <table class="submission-lab-table w-full min-w-full table-auto border-collapse text-left">
          <thead class="border-b border-line bg-surface-sunken/70">
            <tr>
              <th data-column-key="action"
                class="submission-table-header-cell w-[88px] min-w-[88px] max-w-[88px] p-2 align-top text-[10.5px] font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('action')" (mousedown)="startTableHeaderResize('action', $event)">
                Action
                <button #queueModeTrigger
                class="mt-2 flex h-6 w-full items-center justify-between rounded-md border border-line bg-surface-elevated px-2 text-[11px] text-text-primary"
                  type="button" [attr.aria-expanded]="queueModeMenuOpen()" (click)="toggleQueueModeMenu($event)">
                  <span class="truncate text-[11px]">{{ queueModeSelectionLabel() }}</span>
                  <uw-icon name="chevron-down" [size]="11" class="text-text-muted" />
                </button>
              </th>

              <ng-container *ngFor="let columnKey of renderedColumnKeys(); trackBy: trackByTableColumnKey">
                <ng-container [ngSwitch]="columnKey">
              <ng-container *ngSwitchCase="'submissionStatus'">
              <th data-column-key="submissionStatus" draggable="true"
                (dragstart)="startTableHeaderDrag('submissionStatus', $event)" (dragover)="allowTableHeaderDrop($event)"
                (drop)="dropTableHeader('submissionStatus', $event)"
                class="submission-table-header-cell w-[140px] min-w-[140px] max-w-[180px] p-2 align-top text-[10.5px] font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('submissionStatus')"
                (mousedown)="startTableHeaderResize('submissionStatus', $event)">
                <button class="flex w-full cursor-pointer items-center gap-1 text-[11px]" type="button"
                  (click)="toggleSort('submissionStatus')">Sub Status <uw-icon
                    [name]="getSortIconName('submissionStatus')" [size]="11" class="text-text-muted" /></button>
                <button #submissionStatusTrigger
                class="mt-2 flex h-6 w-full items-center justify-between rounded-md border border-line bg-surface-elevated px-2 text-[11px] text-text-primary"
                  type="button" [attr.aria-expanded]="submissionStatusMenuOpen()"
                  (click)="toggleSubmissionStatusMenu($event)"><span class="truncate">{{
                    submissionStatusSelectionLabel() }}</span><uw-icon name="chevron-down" [size]="11"
                    class="text-text-muted" /></button>
              </th>
              </ng-container>
              <ng-container *ngSwitchCase="'evaluationStatus'">
              <th data-column-key="evaluationStatus" draggable="true"
                (dragstart)="startTableHeaderDrag('evaluationStatus', $event)" (dragover)="allowTableHeaderDrop($event)"
                (drop)="dropTableHeader('evaluationStatus', $event)"
                class="submission-table-header-cell w-[170px] min-w-[170px] max-w-[220px] p-2 align-top text-[10.5px] font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('evaluationStatus')"
                (mousedown)="startTableHeaderResize('evaluationStatus', $event)">
                <button class="flex w-full cursor-pointer items-center gap-1 text-[11px]" type="button"
                  (click)="toggleSort('evaluationStatus')">Eval Status <uw-icon
                    [name]="getSortIconName('evaluationStatus')" [size]="11" class="text-text-muted" /></button>
                <div class="relative mt-2"><input
                class="h-7 w-full rounded-md border border-line bg-surface-elevated px-2 pr-7 text-xs text-text-primary outline-none focus:border-primary focus:ring-2 focus:ring-primary/10"
                    type="text" placeholder="Search" [value]="getColumnFilterValue('evaluationStatus')"
                    (input)="updateColumnFilter('evaluationStatus', $event)" />
                  @if (getColumnFilterValue('evaluationStatus')) { <button
                    class="absolute right-2 top-1/2 -translate-y-1/2 text-text-muted" type="button"
                    (click)="clearColumnFilter('evaluationStatus')"><uw-icon name="x" [size]="11" /></button> }
                </div>
              </th>
              </ng-container>
              <ng-container *ngSwitchCase="'id'">
              <th data-column-key="id" draggable="true" (dragstart)="startTableHeaderDrag('id', $event)"
                (dragover)="allowTableHeaderDrop($event)" (drop)="dropTableHeader('id', $event)"
                class="submission-table-header-cell w-[110px] min-w-[110px] max-w-[140px] p-2 align-top text-[10.5px] font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('id')" (mousedown)="startTableHeaderResize('id', $event)">
                <button class="flex w-full cursor-pointer items-center gap-1 text-[11px]" type="button"
                  (click)="toggleSort('id')">Subm # <uw-icon [name]="getSortIconName('id')" [size]="11"
                    class="text-text-muted" /></button>
                <div class="relative mt-2"><input
                class="h-7 w-full rounded-md border border-line bg-surface-elevated px-2 pr-7 text-xs text-text-primary outline-none focus:border-primary"
                    type="text" placeholder="Search" [value]="getColumnFilterValue('id')"
                    (input)="updateColumnFilter('id', $event)" /> @if (getColumnFilterValue('id')) { <button
                    class="absolute right-2 top-1/2 -translate-y-1/2 text-text-muted" type="button"
                    (click)="clearColumnFilter('id')"><uw-icon name="x" [size]="11" /></button> }</div>
              </th>
              </ng-container>
              <ng-container *ngSwitchCase="'submitDate'">
              <th data-column-key="submitDate" draggable="true" (dragstart)="startTableHeaderDrag('submitDate', $event)"
                (dragover)="allowTableHeaderDrop($event)" (drop)="dropTableHeader('submitDate', $event)"
                class="submission-table-header-cell w-[150px] min-w-[150px] max-w-[200px] p-2 align-top text-[10.5px] font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('submitDate')"
                (mousedown)="startTableHeaderResize('submitDate', $event)">
                <button class="flex w-full cursor-pointer items-center gap-1 text-[11px]" type="button"
                  (click)="toggleSort('submitDate')">Submit Date <uw-icon [name]="getSortIconName('submitDate')"
                    [size]="11" class="text-text-muted" /></button>
                <uw-date
                  class="mt-2 block"
                  mode="single"
                  placeholder="Select date"
                  [clearable]="true"
                  [label]="''"
                  [hint]="''"
                  [required]="false"
                  [min]="null"
                  [max]="null"
                  [value]="getColumnFilterValue('submitDate') || null"
                  (changed)="handleDateFilterChange('submitDate', $event)">
                </uw-date>
              </th>
              </ng-container>
              <ng-container *ngSwitchCase="'insured'">
              <th data-column-key="insured" draggable="true" (dragstart)="startTableHeaderDrag('insured', $event)"
                (dragover)="allowTableHeaderDrop($event)" (drop)="dropTableHeader('insured', $event)"
                class="submission-table-header-cell w-[280px] min-w-[220px] max-w-[360px] p-2 align-top text-[10.5px] font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('insured')"
                (mousedown)="startTableHeaderResize('insured', $event)">
                <button class="flex w-full cursor-pointer items-center gap-1 text-[11px]" type="button"
                  (click)="toggleSort('insured')">Insured <uw-icon [name]="getSortIconName('insured')" [size]="11"
                    class="text-text-muted" /></button>
                <div class="relative mt-2"><input
                class="h-7 w-full rounded-md border border-line bg-surface-elevated px-2 pr-7 text-xs text-text-primary outline-none focus:border-primary"
                    type="text" placeholder="Search" [value]="getColumnFilterValue('insured')"
                    (input)="updateColumnFilter('insured', $event)" /> @if (getColumnFilterValue('insured')) { <button
                    class="absolute right-2 top-1/2 -translate-y-1/2 text-text-muted" type="button"
                    (click)="clearColumnFilter('insured')"><uw-icon name="x" [size]="11" /></button> }</div>
              </th>
              </ng-container>
              <ng-container *ngSwitchCase="'underwriter'">
              <th data-column-key="underwriter" draggable="true"
                (dragstart)="startTableHeaderDrag('underwriter', $event)" (dragover)="allowTableHeaderDrop($event)"
                (drop)="dropTableHeader('underwriter', $event)"
                class="submission-table-header-cell w-[170px] min-w-[170px] max-w-[240px] p-2 align-top text-[10.5px] font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('underwriter')"
                (mousedown)="startTableHeaderResize('underwriter', $event)">
                <button class="flex w-full cursor-pointer items-center gap-1 text-[11px]" type="button"
                  (click)="toggleSort('underwriter')">Underwriter
                  <uw-icon [name]="getSortIconName('underwriter')" [size]="11" class="text-text-muted" /></button>
                <div class="relative mt-2"><input
                class="h-7 w-full rounded-md border border-line bg-surface-elevated px-2 pr-16 text-xs text-text-primary outline-none focus:border-primary"
                    type="text" placeholder="Search" [value]="getColumnFilterValue('underwriter')"
                    (input)="updateColumnFilter('underwriter', $event)" />
                  @if (getColumnFilterValue('underwriter')) { <button
                    class="absolute right-8 top-1/2 -translate-y-1/2 text-text-muted" type="button"
                    (click)="clearColumnFilter('underwriter')"><uw-icon name="x" [size]="11" /></button> }
                  <button #underwriterTrigger
                    class="absolute right-1 top-1/2 flex h-6 w-6 -translate-y-1/2 items-center justify-center rounded-md text-text-muted hover:text-primary"
                    type="button" [attr.aria-expanded]="underwriterMenuOpen()"
                    (click)="toggleUnderwriterMenu($event)"><uw-icon name="search" [size]="11" /></button>
                </div>
              </th>
              </ng-container>
              <ng-container *ngSwitchCase="'quoteId'">
              <th data-column-key="quoteId" draggable="true" (dragstart)="startTableHeaderDrag('quoteId', $event)"
                (dragover)="allowTableHeaderDrop($event)" (drop)="dropTableHeader('quoteId', $event)"
                class="submission-table-header-cell w-[140px] min-w-[140px] max-w-[190px] p-2 align-top text-xs font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('quoteId')"
                (mousedown)="startTableHeaderResize('quoteId', $event)">
                <button class="flex w-full cursor-pointer items-center gap-1" type="button"
                  (click)="toggleSort('quoteId')">Quote # <uw-icon [name]="getSortIconName('quoteId')" [size]="11"
                    class="text-text-muted" /></button>
                <div class="relative mt-2"><input
                    class="h-7 w-full rounded-md border border-line bg-surface-elevated px-2 pr-7 text-xs text-text-primary outline-none focus:border-primary"
                    type="text" placeholder="Search" [value]="getColumnFilterValue('quoteId')"
                    (input)="updateColumnFilter('quoteId', $event)" /> @if (getColumnFilterValue('quoteId')) { <button
                    class="absolute right-2 top-1/2 -translate-y-1/2 text-text-muted" type="button"
                    (click)="clearColumnFilter('quoteId')"><uw-icon name="x" [size]="11" /></button> }</div>
              </th>
              </ng-container>
              <ng-container *ngSwitchCase="'applicationType'">
              <th data-column-key="applicationType" draggable="true"
                (dragstart)="startTableHeaderDrag('applicationType', $event)" (dragover)="allowTableHeaderDrop($event)"
                (drop)="dropTableHeader('applicationType', $event)"
                class="submission-table-header-cell w-[140px] min-w-[140px] max-w-[200px] p-2 align-top text-xs font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('applicationType')"
                (mousedown)="startTableHeaderResize('applicationType', $event)">
                <button class="flex w-full cursor-pointer items-center gap-1" type="button"
                  (click)="toggleSort('applicationType')">App Type
                  <uw-icon [name]="getSortIconName('applicationType')" [size]="11" class="text-text-muted" /></button><button #applicationTypeTrigger
                  class="mt-2 flex h-7 w-full items-center justify-between rounded-md border border-line bg-surface-elevated px-2 text-xs text-text-primary"
                  type="button" [attr.aria-expanded]="applicationTypeMenuOpen()"
                  (click)="toggleApplicationTypeMenu($event)"><span class="truncate">{{ applicationTypeSelectionLabel()
                    }}</span><uw-icon name="chevron-down" [size]="11" class="text-text-muted" /></button>
              </th>
              </ng-container>
              <ng-container *ngSwitchCase="'policyNumber'">
              <th data-column-key="policyNumber" draggable="true"
                (dragstart)="startTableHeaderDrag('policyNumber', $event)" (dragover)="allowTableHeaderDrop($event)"
                (drop)="dropTableHeader('policyNumber', $event)"
                class="submission-table-header-cell w-[140px] min-w-[140px] max-w-[200px] p-2 align-top text-xs font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('policyNumber')"
                (mousedown)="startTableHeaderResize('policyNumber', $event)">
                <button class="flex w-full cursor-pointer items-center gap-1" type="button"
                  (click)="toggleSort('policyNumber')">Policy <uw-icon
                    [name]="getSortIconName('policyNumber')" [size]="11" class="text-text-muted" /></button>
                <div class="relative mt-2"><input
                class="h-7 w-full rounded-md border border-line bg-surface-elevated px-2 pr-7 text-xs text-text-primary outline-none focus:border-primary"
                    type="text" placeholder="Search" [value]="getColumnFilterValue('policyNumber')"
                    (input)="updateColumnFilter('policyNumber', $event)" /> @if (getColumnFilterValue('policyNumber')) {
                  <button class="absolute right-2 top-1/2 -translate-y-1/2 text-text-muted" type="button"
                    (click)="clearColumnFilter('policyNumber')"><uw-icon name="x" [size]="11" /></button> }
                </div>
              </th>
              </ng-container>
              <ng-container *ngSwitchCase="'line'">
              <th data-column-key="line" draggable="true" (dragstart)="startTableHeaderDrag('line', $event)"
                (dragover)="allowTableHeaderDrop($event)" (drop)="dropTableHeader('line', $event)"
                class="submission-table-header-cell w-[140px] min-w-[140px] max-w-[220px] p-2 align-top text-xs font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('line')" (mousedown)="startTableHeaderResize('line', $event)">
                <button class="flex w-full cursor-pointer items-center gap-1" type="button"
                  (click)="toggleSort('line')">Line <uw-icon [name]="getSortIconName('line')" [size]="11"
                    class="text-text-muted" /></button>
                <div class="relative mt-2"><input
                class="h-7 w-full rounded-md border border-line bg-surface-elevated px-2 pr-7 text-xs text-text-primary outline-none focus:border-primary"
                    type="text" placeholder="Search" [value]="getColumnFilterValue('line')"
                    (input)="updateColumnFilter('line', $event)" /> @if (getColumnFilterValue('line')) { <button
                    class="absolute right-2 top-1/2 -translate-y-1/2 text-text-muted" type="button"
                    (click)="clearColumnFilter('line')"><uw-icon name="x" [size]="11" /></button> }</div>
              </th>
              </ng-container>
              <ng-container *ngSwitchCase="'submissionType'">
              <th data-column-key="submissionType" draggable="true"
                (dragstart)="startTableHeaderDrag('submissionType', $event)" (dragover)="allowTableHeaderDrop($event)"
                (drop)="dropTableHeader('submissionType', $event)"
                class="submission-table-header-cell w-[150px] min-w-[150px] max-w-[220px] p-3 align-top text-xs font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('submissionType')"
                (mousedown)="startTableHeaderResize('submissionType', $event)">
                <button class="flex w-full cursor-pointer items-center gap-1" type="button"
                  (click)="toggleSort('submissionType')">Type <uw-icon [name]="getSortIconName('submissionType')"
                    [size]="11" class="text-text-muted" /></button>
                <div class="relative mt-2"><input
                class="h-7 w-full rounded-md border border-line bg-surface-elevated px-2 pr-7 text-xs text-text-primary outline-none focus:border-primary"
                    type="text" placeholder="Search" [value]="getColumnFilterValue('submissionType')"
                    (input)="updateColumnFilter('submissionType', $event)" /> @if
                  (getColumnFilterValue('submissionType')) { <button
                    class="absolute right-2 top-1/2 -translate-y-1/2 text-text-muted" type="button"
                    (click)="clearColumnFilter('submissionType')"><uw-icon name="x" [size]="11" /></button> }</div>
              </th>
              </ng-container>
              <ng-container *ngSwitchCase="'riskAppetite'">
              <th data-column-key="riskAppetite" draggable="true"
                (dragstart)="startTableHeaderDrag('riskAppetite', $event)" (dragover)="allowTableHeaderDrop($event)"
                (drop)="dropTableHeader('riskAppetite', $event)"
                class="submission-table-header-cell w-[130px] min-w-[130px] max-w-[170px] p-2 align-top text-xs font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('riskAppetite')"
                (mousedown)="startTableHeaderResize('riskAppetite', $event)">
                <button class="flex w-full cursor-pointer items-center gap-1" type="button"
                  (click)="toggleSort('riskAppetite')">Risk
                  Appetite <uw-icon [name]="getSortIconName('riskAppetite')" [size]="11" class="text-text-muted" /></button>
                <div class="relative mt-2"><input
                class="h-7 w-full rounded-md border border-line bg-surface-elevated px-2 pr-7 text-xs text-text-primary outline-none focus:border-primary"
                    type="text" placeholder="Search" [value]="getColumnFilterValue('riskAppetite')"
                    (input)="updateColumnFilter('riskAppetite', $event)" /> @if (getColumnFilterValue('riskAppetite')) {
                  <button class="absolute right-2 top-1/2 -translate-y-1/2 text-text-muted" type="button"
                    (click)="clearColumnFilter('riskAppetite')"><uw-icon name="x" [size]="11" /></button> }
                </div>
              </th>
              </ng-container>
              <ng-container *ngSwitchCase="'bindPropensity'">
              <th data-column-key="bindPropensity" draggable="true"
                (dragstart)="startTableHeaderDrag('bindPropensity', $event)" (dragover)="allowTableHeaderDrop($event)"
                (drop)="dropTableHeader('bindPropensity', $event)"
                class="submission-table-header-cell w-[130px] min-w-[130px] max-w-[170px] p-2 align-top text-xs font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('bindPropensity')"
                (mousedown)="startTableHeaderResize('bindPropensity', $event)">
                <button class="flex w-full cursor-pointer items-center gap-1" type="button"
                  (click)="toggleSort('bindPropensity')">Bind Prop#
                  <uw-icon [name]="getSortIconName('bindPropensity')" [size]="11" class="text-text-muted" /></button>
                <div class="relative mt-2"><input
                    class="h-7 w-full rounded-md border border-line bg-surface-elevated px-2 pr-7 text-xs text-text-primary outline-none focus:border-primary"
                    type="text" placeholder="Search" [value]="getColumnFilterValue('bindPropensity')"
                    (input)="updateColumnFilter('bindPropensity', $event)" /> @if
                  (getColumnFilterValue('bindPropensity')) { <button
                    class="absolute right-2 top-1/2 -translate-y-1/2 text-text-muted" type="button"
                    (click)="clearColumnFilter('bindPropensity')"><uw-icon name="x" [size]="11" /></button> }</div>
              </th>
              </ng-container>
              <ng-container *ngSwitchCase="'dataQualityScore'">
              <th data-column-key="dataQualityScore" draggable="true"
                (dragstart)="startTableHeaderDrag('dataQualityScore', $event)" (dragover)="allowTableHeaderDrop($event)"
                (drop)="dropTableHeader('dataQualityScore', $event)"
                class="submission-table-header-cell w-[130px] min-w-[130px] max-w-[170px] p-2 align-top text-xs font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('dataQualityScore')"
                (mousedown)="startTableHeaderResize('dataQualityScore', $event)">
                <button class="flex w-full cursor-pointer items-center gap-1" type="button"
                  (click)="toggleSort('dataQualityScore')">Data
                  Quality <uw-icon [name]="getSortIconName('dataQualityScore')" [size]="11" class="text-text-muted" /></button>
                <div class="relative mt-2"><input
                    class="h-7 w-full rounded-md border border-line bg-surface-elevated px-2 pr-7 text-xs text-text-primary outline-none focus:border-primary"
                    type="text" placeholder="Search" [value]="getColumnFilterValue('dataQualityScore')"
                    (input)="updateColumnFilter('dataQualityScore', $event)" /> @if
                  (getColumnFilterValue('dataQualityScore')) { <button
                    class="absolute right-2 top-1/2 -translate-y-1/2 text-text-muted" type="button"
                    (click)="clearColumnFilter('dataQualityScore')"><uw-icon name="x" [size]="11" /></button> }</div>
              </th>
              </ng-container>
              <ng-container *ngSwitchCase="'effectiveDate'">
              <th data-column-key="effectiveDate" draggable="true"
                (dragstart)="startTableHeaderDrag('effectiveDate', $event)" (dragover)="allowTableHeaderDrop($event)"
                (drop)="dropTableHeader('effectiveDate', $event)"
                class="submission-table-header-cell w-[150px] min-w-[150px] max-w-[200px] p-2 align-top text-xs font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('effectiveDate')"
                (mousedown)="startTableHeaderResize('effectiveDate', $event)">
                <button class="flex w-full cursor-pointer items-center gap-1" type="button"
                  (click)="toggleSort('effectiveDate')">Effective
                  Date <uw-icon [name]="getSortIconName('effectiveDate')" [size]="11" class="text-text-muted" /></button>
                <uw-date
                  class="mt-2 block"
                  mode="single"
                  placeholder="Select date"
                  [clearable]="true"
                  [label]="''"
                  [hint]="''"
                  [required]="false"
                  [min]="null"
                  [max]="null"
                  [value]="getColumnFilterValue('effectiveDate') || null"
                  (changed)="handleDateFilterChange('effectiveDate', $event)">
                </uw-date>
              </th>
              </ng-container>
              <ng-container *ngSwitchCase="'annualRevenue'">
              <th data-column-key="annualRevenue" draggable="true"
                (dragstart)="startTableHeaderDrag('annualRevenue', $event)" (dragover)="allowTableHeaderDrop($event)"
                (drop)="dropTableHeader('annualRevenue', $event)"
                class="submission-table-header-cell w-[150px] min-w-[150px] max-w-[220px] p-2 align-top text-xs font-semibold text-text-secondary"
                [style.width.px]="getTableHeaderWidth('annualRevenue')"
                (mousedown)="startTableHeaderResize('annualRevenue', $event)">
                <button class="flex w-full cursor-pointer items-center gap-1" type="button"
                  (click)="toggleSort('annualRevenue')">Revenue <uw-icon [name]="getSortIconName('annualRevenue')"
                    [size]="11" class="text-text-muted" /></button>
                <div class="relative mt-2"><input
                class="h-7 w-full rounded-md border border-line bg-surface-elevated px-2 pr-7 text-xs text-text-primary outline-none focus:border-primary"
                    type="text" placeholder="Search" [value]="getColumnFilterValue('annualRevenue')"
                    (input)="updateColumnFilter('annualRevenue', $event)" /> @if (getColumnFilterValue('annualRevenue'))
                  { <button class="absolute right-2 top-1/2 -translate-y-1/2 text-text-muted" type="button"
                    (click)="clearColumnFilter('annualRevenue')"><uw-icon name="x" [size]="11" /></button> }</div>
              </th>
                </ng-container>
              </ng-container>
              </ng-container>
            </tr>
          </thead>

          <tbody class="divide-y divide-line">
            @for (row of visibleRows(); track row.id) {
            <tr [ngClass]="submissionRowClass(row)"
              class="h-9 transition hover:bg-surface-sunken/70">
              <td data-column-key="action" class="p-2 align-middle text-center">
                <button
                  class="submission-lab-action group relative inline-flex h-[1.625rem] w-[1.625rem] items-center justify-center overflow-visible bg-surface align-middle transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 disabled:cursor-not-allowed disabled:opacity-50"
                  [uwTooltip]="getActionTitle(row)"
                  [attr.data-uw-tooltip-placement]="'right'"
                  [class.border-primary]="showActionProcessed(row) || showActionProgress(row)"
                  [class.bg-primary-soft]="showActionProcessed(row)"
                  [class.bg-ai-soft]="showActionProgress(row)"
                  [class.shadow-sm]="showActionProcessed(row) || showActionProgress(row)"
                  [class.shadow-none]="!showActionProcessed(row) && !showActionProgress(row)"
                  type="button"
                  [attr.aria-label]="'Open insights for submission ' + row.id"
                  [attr.title]="getActionTitle(row)"
                  [disabled]="isActionDisabled(row)"
                  (click)="$event.stopPropagation(); openSubmissionDetails(row)">
                  @if (showActionProgress(row)) {
                  <span class="absolute inset-0 flex items-center justify-center">
                    <svg class="absolute left-1/2 top-1/2 h-7 w-7 -translate-x-1/2 -translate-y-1/2 -rotate-90 overflow-visible" viewBox="0 0 24 24" aria-hidden="true">
                      <circle cx="12" cy="12" r="8.5" fill="none" stroke="var(--cp-border-strong)" stroke-width="3.2" opacity="0.35"></circle>
                      @for (segment of getActionProgressRingSegments(row); track segment.index) {
                      <circle
                        cx="12"
                        cy="12"
                        r="8.5"
                        fill="none"
                        stroke-linecap="round"
                        stroke-width="3.2"
                        [style.stroke]="segment.color"
                        [attr.stroke-dasharray]="segment.dasharray"
                        [attr.stroke-dashoffset]="segment.dashoffset"
                      ></circle>
                      }
                    </svg>
                    <span class="relative z-10 flex h-4 w-4 items-center justify-center rounded-full bg-surface text-[7px] font-bold leading-none text-text-primary">
                      {{ getActionProgressStageLabel(row) }}
                    </span>
                  </span>
                  } @else if (showActionProcessed(row)) {
                  <span class="absolute inset-0 flex items-center justify-center">
                    <svg class="absolute left-1/2 top-1/2 h-7 w-7 -translate-x-1/2 -translate-y-1/2 -rotate-90 overflow-visible" viewBox="0 0 24 24" aria-hidden="true">
                      <circle cx="12" cy="12" r="8.5" fill="none" stroke="var(--cp-border-strong)" stroke-width="3.2" opacity="0.35"></circle>
                      @for (segment of getActionCompletedRingSegments(row); track segment.index) {
                      <circle
                        cx="12"
                        cy="12"
                        r="8.5"
                        fill="none"
                        stroke-linecap="round"
                        stroke-width="3.2"
                        [style.stroke]="segment.color"
                        [attr.stroke-dasharray]="segment.dasharray"
                        [attr.stroke-dashoffset]="segment.dashoffset"
                      ></circle>
                      }
                    </svg>
                    <span class="relative z-10 flex h-4 w-4 items-center justify-center rounded-full bg-surface">
                      <uw-icon [name]="getProcessedCheckIcon(row)" [size]="9" [strokeWidth]="3.2" [style.color]="getCheckColor(row)"></uw-icon>
                    </span>
                  </span>
                  } @else if (isCheckingDocuments(row) || isOpeningSubmission(row)) {
                  <uw-icon name="refresh" [size]="14" class="animate-spin text-ai" />
                  } @else if (isActionTemporarilyBlocked(row)) {
                  <uw-icon name="lock" [size]="14" class="text-warning" />
                  } @else if (isActionDisabled(row)) {
                  <uw-icon name="file-search" [size]="14" class="text-text-muted" />
                  } @else {
                  <uw-icon name="chart" [size]="14" class="text-primary" />
                  }
                </button>
              </td>

              <ng-container *ngFor="let columnKey of renderedColumnKeys(); trackBy: trackByTableColumnKey">
                <ng-container [ngSwitch]="columnKey">
              <ng-container *ngSwitchCase="'submissionStatus'"> <td data-column-key="submissionStatus"
                class="p-2.5 typo-body text-text-primary"><uw-badge
                  [tone]="row.submissionStatus === 'SUBMISSION' || row.submissionStatus === 'BOUND' ? 'success' : row.submissionStatus === 'QUOTE' ? 'ai' : row.submissionStatus === 'NO MATCH' ? 'warning' : 'danger'">{{
                  row.submissionStatus }}</uw-badge></td>
              </ng-container>
              <ng-container *ngSwitchCase="'evaluationStatus'"> <td data-column-key="evaluationStatus"
                class="p-2.5 typo-body text-text-primary"><span class="relative" [ngClass]="evaluationStatusClasses(row.evaluationStatus)">{{
                  row.evaluationStatus
                  || 'N/A' }} @if (row.evaluationStatus == 'DECLINE' || row.evaluationStatus == 'FLAGGED') { <button
                    class="ml-1 inline-flex translate-y-[-0.25rem] text-text-muted transition hover:text-primary"
                    type="button" (click)="$event.stopPropagation(); openDeclineReason(row)" title="View Risk Appetite">
                    <uw-icon name="eye" [size]="12" [class]="row.evaluationStatus == 'DECLINE' ? 'text-danger' : 'text-warning'" />
                  </button> }</span>
              </td>
              </ng-container>
              <ng-container *ngSwitchCase="'id'"> <td data-column-key="id"
                class="p-2.5 typo-body font-semibold text-text-primary">{{ row.id }}</td>
              </ng-container>
              <ng-container *ngSwitchCase="'submitDate'"> <td data-column-key="submitDate"
                class="p-2.5 typo-body font-semibold text-text-primary">{{ row.createdAt }}</td>
              </ng-container>
              <ng-container *ngSwitchCase="'insured'"> <td data-column-key="insured"
                class="max-w-[280px] p-2.5 typo-body font-semibold text-text-primary cursor-help"
                [uwTooltip]="(row.insured || 'Insured name unavailable') + ' - ' + (row.effectiveDate || 'N/A')"
                [focusable]="true">
                <span class="block max-w-full truncate">
                  {{ row.insured }}
                </span>
                </td>
              </ng-container>
              <ng-container *ngSwitchCase="'underwriter'"> <td data-column-key="underwriter"
                class="p-2.5 typo-body font-semibold text-text-primary">{{ row.underwriter }}</td>
              </ng-container>
              <ng-container *ngSwitchCase="'quoteId'"> <td data-column-key="quoteId"
                class="p-2.5 typo-body font-semibold text-text-primary">{{ row.quoteId }}</td>
              </ng-container>
              <ng-container *ngSwitchCase="'applicationType'"> <td data-column-key="applicationType"
                class="p-2.5 typo-body font-semibold text-text-primary">{{ row.applicationType }}</td>
              </ng-container>
              <ng-container *ngSwitchCase="'policyNumber'"> <td data-column-key="policyNumber"
                class="p-2.5 typo-body font-semibold text-text-primary">{{ row.policyNumber }}</td>
              </ng-container>
              <ng-container *ngSwitchCase="'line'"> <td data-column-key="line"
                class="p-2.5 typo-body font-semibold text-text-primary cursor-help"
                [uwTooltip]="row.line || 'Line name unavailable'"
                [focusable]="true">
                <span class="block max-w-full truncate">
                  {{ row.line }}
                </span>
              </td>
              </ng-container>
              <ng-container *ngSwitchCase="'submissionType'">
              <td data-column-key="submissionType" class="p-2.5 typo-body font-semibold text-text-primary">
                <!-- <app-tooltip [text]="(row.submissionType || 'SubmissionType name unavailable') | uppercase"
                  position="right"><span class="block truncate">{{ row.submissionType }}</span></app-tooltip> -->
              </td>
              </ng-container>
              <ng-container *ngSwitchCase="'riskAppetite'"> <td data-column-key="riskAppetite"
                class="p-2.5 typo-body font-semibold text-text-primary"><span
                  class="relative inline-block">{{ row.riskAppetite && row.riskAppetite !== 'N/A' ? row.riskAppetite +
                  '/30' : row.riskAppetite }} @if (row.riskAppetite && row.riskAppetite !== 'N/A') { <button
                    class="absolute left-full top-0 ml-1 -translate-y-1/3 cursor-pointer text-primary transition hover:text-primary-hover"
                    type="button" (click)="$event.stopPropagation(); openRiskAppetite(row)" title="View Risk Appetite">
                    <uw-icon name="eye" [size]="12" />
                  </button> }</span>
              </td>
              </ng-container>
              <ng-container *ngSwitchCase="'bindPropensity'"> <td data-column-key="bindPropensity"
                class="p-2.5 typo-body font-semibold text-text-primary">{{ row.bindPropensity }}</td>
              </ng-container>
              <ng-container *ngSwitchCase="'dataQualityScore'"> <td data-column-key="dataQualityScore"
                class="p-2.5 typo-body font-semibold text-text-primary">{{ row.dataQualityScore }}</td>
              </ng-container>
              <ng-container *ngSwitchCase="'effectiveDate'"> <td data-column-key="effectiveDate"
                class="p-2.5 typo-body font-semibold text-text-primary">{{ row.effectiveDate }}</td>
              </ng-container>
              <ng-container *ngSwitchCase="'annualRevenue'"> <td data-column-key="annualRevenue"
                class="p-2.5 typo-body font-semibold text-text-primary">{{ row.annualRevenue == null ? '-'
                : (row.annualRevenue | currency:'USD':'symbol':'1.0-0') }}</td>
              </ng-container>
                </ng-container>
              </ng-container>
            </tr>
            } @empty {
            <tr>
              <td [attr.colspan]="visibleColumnCount() + 1"
                class="h-[400px] p-8 text-center typo-body whitespace-pre-line"
                [ngClass]="tableStateTone() === 'error' ? 'text-danger' : 'text-text-muted'">
                {{ tableStateMessage() }}
              </td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      <div
        class="flex flex-col gap-4 border-t border-line px-4 py-4 md:flex-row md:items-center md:justify-between">
        <div class="flex flex-wrap items-center gap-2 typo-body text-text-secondary">
          <span>Limit</span>
          <span class="rounded-md bg-primary-soft px-3 py-1 font-semibold text-primary">{{ pageLimit() }}</span>
          <span>/</span>
          <span
            class="rounded-md bg-surface-sunken px-3 py-1 font-semibold text-text-primary">{{
            totalCount() }}</span>
          <span>total records</span>
          <span class="mx-1 hidden h-4 w-px bg-line md:block"></span>
          <span>Showing {{ visibleRows().length }} on page {{ currentPage() }}</span>
        </div>

        <div class="flex flex-wrap items-center gap-2 md:justify-end">
          <button
            class="inline-flex h-7 items-center justify-center rounded-md border border-line px-2.5 text-[11px] font-medium text-text-primary transition hover:border-primary hover:text-primary disabled:cursor-not-allowed disabled:opacity-40"
            [disabled]="currentPage() <= 1" type="button" (click)="goToPage(currentPage() - 1)">
            Prev
          </button>

          @for (item of pagerItems(); track $index) {
          @if (item === 'ellipsis') {
          <span
            class="inline-flex h-7 min-w-7 items-center justify-center text-[11px] text-text-muted">...</span>
          } @else {
          <button
            class="inline-flex h-7 min-w-7 items-center justify-center rounded-md border px-2 text-[11px] font-medium transition"
            [class.border-primary]="currentPage() === item" [class.bg-primary]="currentPage() === item"
            [class.text-white]="currentPage() === item" [class.shadow-button]="currentPage() === item"
            [class.border-line]="currentPage() !== item" [class.text-text-primary]="currentPage() !== item"
            [class.hover:border-primary]="currentPage() !== item" [class.hover:text-primary]="currentPage() !== item"
            type="button" (click)="goToPage(item)">
            {{ item }}
          </button>
          }
          }

          <button
            class="inline-flex h-7 items-center justify-center rounded-md border border-line px-2.5 text-[11px] font-medium text-text-primary transition hover:border-primary hover:text-primary disabled:cursor-not-allowed disabled:opacity-40"
            [disabled]="currentPage() >= totalPages()" type="button" (click)="goToPage(currentPage() + 1)">
            Next
          </button>
        </div>
      </div>
    </div>
  </article>

  <!-- @if (submissionStatusMenuOpen() && submissionStatusMenuPosition(); as menuPosition) {
  <div #submissionStatusMenu class="app-table-select-menu app-table-select-menu--overlay"
    [style.top.px]="menuPosition.top" [style.left.px]="menuPosition.left" [style.width.px]="menuPosition.width"
    (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
    @for (statusOption of submissionStatusOptions; track statusOption) {
    <label class="app-table-select-option">
      <input type="checkbox" [checked]="isSubmissionStatusSelected(statusOption)"
        (change)="toggleSubmissionStatusOption(statusOption, $event)" />
      <span>{{ statusOption }}</span>
    </label>
    }
  </div>
  } -->
  @if (submissionStatusMenuOpen() && submissionStatusMenuPosition(); as menuPosition) {
  <div #submissionStatusMenu class="fixed z-[9999] max-w-[calc(100vw-24px)] overflow-hidden rounded-xl border border-line bg-surface-elevated shadow-lg backdrop-blur-xl origin-top submission-dropdown-animation"
    [style.top.px]="menuPosition.top" [style.left.px]="menuPosition.left" [style.width.px]="menuPosition.width"
    (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between border-b border-line px-2.5 py-2">
      <span class="text-[10.5px] font-semibold uppercase tracking-wider text-text-muted">Select Status</span>
      <span class="rounded-full bg-surface-sunken px-2 py-0.5 text-[10px] font-semibold text-text-muted">{{ submissionStatusOptions.length }}</span>
    </div>
    <div class="p-1">
      @for (statusOption of submissionStatusOptions; track statusOption) {
      <label class="group flex cursor-pointer items-center gap-2 rounded-lg px-2.5 py-1.5 transition-colors hover:bg-surface-sunken">
        <span class="relative flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-[4px] border border-line bg-surface transition-all duration-150 group-hover:border-primary group-hover:bg-primary-soft">
          <input type="checkbox" class="peer absolute inset-0 h-full w-full cursor-pointer opacity-0" [checked]="isSubmissionStatusSelected(statusOption)"
            (change)="toggleSubmissionStatusOption(statusOption, $event)" />
          <svg class="pointer-events-none h-3 w-3 scale-0 text-primary transition-transform duration-150 peer-checked:scale-100" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.5">
            <path d="M4 10.5l4 4 8-9" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
        <span class="flex-1 text-[11px] font-medium leading-4 text-text-primary transition-colors duration-150 group-hover:text-primary">{{ statusOption }}</span>
        @if (isSubmissionStatusSelected(statusOption)) {
        <span class="h-1.5 w-1.5 rounded-full bg-primary shadow-[0_0_7px_rgba(34,57,95,0.35)]"></span>
        }
      </label>
      }
    </div>
  </div>
  }
  <!-- @if (applicationTypeMenuOpen() && applicationTypeMenuPosition(); as appTypeMenuPosition) {
  <div #applicationTypeMenu class="app-table-select-menu app-table-select-menu--overlay" style="min-width: 230px;"
    [style.top.px]="appTypeMenuPosition.top" [style.left.px]="appTypeMenuPosition.left"
    [style.width.px]="appTypeMenuPosition.width" (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()">
    @for (applicationTypeOption of applicationTypeOptions; track applicationTypeOption) {
    @for (appTypeLabel of appTypeLabels; track appTypeLabel.key) {
    @if (appTypeLabel.key === applicationTypeOption) {
    <label class="app-table-select-option">
      <input type="checkbox" [checked]="isApplicationTypeSelected(applicationTypeOption)"
        (change)="toggleApplicationTypeOption(applicationTypeOption, $event)" />
      <span>{{ appTypeLabel.key }} - {{ appTypeLabel.value }}</span>
    </label>
    }
    }
    }
  </div>
  } -->
  @if (applicationTypeMenuOpen() && applicationTypeMenuPosition(); as appTypeMenuPosition) {
  <div #applicationTypeMenu class="fixed z-[9999] min-w-[210px] max-w-[calc(100vw-24px)] overflow-hidden rounded-xl border border-line bg-surface-elevated shadow-lg backdrop-blur-xl origin-top submission-dropdown-animation"
    [style.top.px]="appTypeMenuPosition.top" [style.left.px]="appTypeMenuPosition.left" [style.width.px]="appTypeMenuPosition.width"
    (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between border-b border-line px-2.5 py-2">
      <span class="text-[10.5px] font-semibold uppercase tracking-wider text-text-muted">Application Type</span>
      <span class="rounded-full bg-surface-sunken px-2 py-0.5 text-[10px] font-semibold text-text-muted">{{ applicationTypeOptions.length }}</span>
    </div>
    <div class="p-1">
      @for (applicationTypeOption of applicationTypeOptions; track applicationTypeOption) {
      @for (appTypeLabel of appTypeLabels; track appTypeLabel.key) {
      @if (appTypeLabel.key === applicationTypeOption) {
      <label class="group flex cursor-pointer items-center gap-2 rounded-lg px-2.5 py-1.5 transition-colors hover:bg-surface-sunken">
        <span class="relative flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-[4px] border border-line bg-surface transition-all duration-150 group-hover:border-primary group-hover:bg-primary-soft">
          <input type="checkbox" class="peer absolute inset-0 h-full w-full cursor-pointer opacity-0" [checked]="isApplicationTypeSelected(applicationTypeOption)"
            (change)="toggleApplicationTypeOption(applicationTypeOption, $event)" />
          <svg class="pointer-events-none h-3 w-3 scale-0 text-primary transition-transform duration-150 peer-checked:scale-100" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.5">
            <path d="M4 10.5l4 4 8-9" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </span>
        <span class="flex-1 text-[11px] font-medium leading-4 text-text-primary transition-colors duration-150 group-hover:text-primary">{{ appTypeLabel.key }} - {{ appTypeLabel.value }}</span>
        @if (isApplicationTypeSelected(applicationTypeOption)) {
        <span class="h-1.5 w-1.5 shrink-0 rounded-full bg-primary shadow-[0_0_7px_rgba(34,57,95,0.35)]"></span>
        }
      </label>
      }
      }
      }
    </div>
  </div>
  }
  <!-- @if (queueModeMenuOpen() && queueModeMenuPosition(); as queueModeMenuPosition) {
  <div #queueModeMenu class="app-table-select-menu app-table-select-menu--overlay"
    [style.top.px]="queueModeMenuPosition.top" [style.left.px]="queueModeMenuPosition.left"
    [style.width.px]="queueModeMenuPosition.width" (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation()">
    @for (queueModeOption of queueModeOptions; track queueModeOption.value) {
    <button class="app-table-underwriter-option mb-1"
      [class.app-table-underwriter-option--active]="isQueueModeSelected(queueModeOption.value)" type="button"
      (click)="selectQueueMode(queueModeOption.value, $event)">
      <span class="app-table-underwriter-option__name"><i
          class="fa-solid + {{queueModeOption.icon}} ml-1 mr-2 app-table-filter-option__icon"></i>
        <span class="ml-2 ">
          {{ queueModeOption.label }}
        </span> </span>
    </button>
    }
  </div>
  } -->
  @if (queueModeMenuOpen() && queueModeMenuPosition(); as queueModeMenuPosition) {
  <div #queueModeMenu class="fixed z-[9999] min-w-[180px] max-w-[calc(100vw-24px)] overflow-hidden rounded-xl border border-line bg-surface-elevated p-1 shadow-lg backdrop-blur-xl origin-top app-dropdown-animation"
    [style.top.px]="queueModeMenuPosition.top" [style.left.px]="queueModeMenuPosition.left" [style.width.px]="queueModeMenuPosition.width"
    (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
    <div class="mb-1 flex items-center border-b border-line px-2.5 py-2">
      <span class="text-[10.5px] font-semibold uppercase tracking-wider text-text-muted">Queue Mode</span>
    </div>
    @for (queueModeOption of queueModeOptions; track queueModeOption.value) {
    <button type="button" class="group relative mb-0.5 flex w-full items-center rounded-lg px-2.5 py-1.5 text-left transition-colors duration-150 text-text-primary hover:bg-surface-sunken"
      [class.bg-primary-soft]="isQueueModeSelected(queueModeOption.value)" [class.text-primary]="isQueueModeSelected(queueModeOption.value)"
      (click)="selectQueueMode(queueModeOption.value, $event)">
      <span class="absolute left-0 h-5 w-[3px] rounded-r-full bg-primary opacity-0 transition-opacity duration-150"
        [class.opacity-100]="isQueueModeSelected(queueModeOption.value)"></span>
      <span class="flex h-5 w-5 shrink-0 items-center justify-center rounded-md bg-surface text-text-muted transition-all duration-150 group-hover:bg-surface-elevated group-hover:text-text-primary"
        [class.bg-primary-soft]="isQueueModeSelected(queueModeOption.value)" [class.text-primary]="isQueueModeSelected(queueModeOption.value)">
        <uw-icon [name]="queueModeOption.icon ?? 'sliders-horizontal'" [size]="11" />
      </span>
      <span class="ml-2.5 flex-1 text-[11px] font-medium leading-4">{{ queueModeOption.label }}</span>
      @if (isQueueModeSelected(queueModeOption.value)) {
      <span class="flex h-4 w-4 items-center justify-center rounded-full bg-primary text-white shadow-[0_0_8px_rgba(34,57,95,0.25)]">
        <uw-icon name="check" [size]="9" />
      </span>
      }
    </button>
    }
  </div>
  }
  @if (underwriterMenuOpen() && underwriterMenuPosition(); as underwriterMenuPosition) {
  <div #underwriterMenu class="fixed z-[9999] max-w-[calc(100vw-24px)] overflow-hidden rounded-xl border border-line bg-surface-elevated shadow-lg backdrop-blur-xl origin-top"
    [style.top.px]="underwriterMenuPosition.top" [style.left.px]="underwriterMenuPosition.left" [style.width.px]="underwriterMenuPosition.width"
    (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
    <div class="border-b border-line p-2">
      <div class="flex items-center gap-2 rounded-lg border border-line bg-surface px-2 py-1.5">
        <uw-icon name="search" [size]="11" class="text-text-muted" />
        <input class="w-full bg-transparent text-[11.5px] text-text-primary placeholder:text-text-muted focus:outline-none" type="text" placeholder="Search underwriter"
          [value]="underwriterSearchTerm()" (input)="updateUnderwriterSearch($event)" />
      </div>
    </div>
    <div class="max-h-[280px] overflow-auto p-1">
      @for (underwriterOption of filteredUnderwriterOptions(); track underwriterOption.sr_no) {
      <button class="mb-1 flex w-full items-center justify-between rounded-lg px-2.5 py-1.5 text-left transition-colors hover:bg-surface-sunken"
        [class.bg-primary-soft]="isUnderwriterSelected(underwriterOption.name)" [class.text-primary]="isUnderwriterSelected(underwriterOption.name)" type="button"
        (click)="selectUnderwriter(underwriterOption.name, $event)">
        <span class="text-[11px] font-medium leading-4">{{ underwriterOption.name }}</span>
        <span class="rounded-full bg-surface-sunken px-2 py-0.5 text-[10px] font-semibold text-text-muted">UW #{{ underwriterOption.sr_no }}</span>
      </button>
      } @empty {
      <div class="rounded-lg border border-dashed border-line px-3 py-4 text-center text-[11px] text-text-muted">No underwriters found.</div>
      }
    </div>
  </div>
  }

</section>

